/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { COLUMNTYPE_TIMESTAMP, DATAITEM_TYPE_DERIVED } from 'constants';

import get from 'lodash/get';

import { DATAITEM_TYPE_DERIVED_DIMENSION, AGGREGATE } from '../constants/constants';

import {
  GET_AVAILABLE_AGGREGATES,
  GET_AVAILABLE_AGGREGATES_FAILURE,
  GET_AVAILABLE_AGGREGATES_SUCCESS,
} from 'granularityActionCreators';
import { reduceFetchedData } from 'reducerUtils';
import { getDataItemsOfTypeColumnType } from 'dataItemsReducer';

// reducers
export const availableAggregatesReducer = (state, action) =>
  reduceFetchedData(
    state,
    action,
    GET_AVAILABLE_AGGREGATES,
    GET_AVAILABLE_AGGREGATES_SUCCESS,
    GET_AVAILABLE_AGGREGATES_FAILURE
  );

// selectors
export const getAvailableAggregates = state =>
  getDataItemsOfTypeColumnType(state, DATAITEM_TYPE_DERIVED_DIMENSION, COLUMNTYPE_TIMESTAMP)
    .concat(getDataItemsOfTypeColumnType(state, DATAITEM_TYPE_DERIVED, COLUMNTYPE_TIMESTAMP))
    .concat(
      // First get Timestamp data items, then add the default aggregates
      Object.values(get(state, 'availableAggregates.data')).map(aggregate => ({
        ...aggregate,
        type: AGGREGATE,
      })) || []
    );

export const isFetchingAggregates = state =>
  get(state, 'availableAggregates.fetchingData') || get(state, 'dataItems.fetchingData');
